
import { observer } from 'mobx-react';
import React from 'react';

import { SplitLineItemResult } from '../.././pages/page-payment-success/page-payment-success-view-model';
import { Text } from '../../components/text';
import { PaymentLabel, WebGivingPaymentResultStatus } from '../../webgiving-generated';
import { LineItemSummaryTable, isFailedPayment } from './line-item-summary-table';

type LineItemGiftCompleteProps = {
    splitLineItemResults: SplitLineItemResult[];
    emailAddress: string;
    paymentLabel: PaymentLabel;
    isRecurring?: boolean;
    isOneTimeFutureGift?: boolean;
    secondPart?: string | JSX.Element;
    statusText?: string;
    recurringSuggestion?: false | JSX.Element;
}

export const LineItemGiftComplete = observer(({
    splitLineItemResults,
    emailAddress,
    paymentLabel,
    isRecurring,
    isOneTimeFutureGift,
    secondPart,
    statusText,
    recurringSuggestion,
}: LineItemGiftCompleteProps) => {

    const { NounLowerCase, NounPluralLowerCase } = paymentLabel;
    const hasAnyFailedPayments = splitLineItemResults.some(isFailedPayment);
    const arePaymentsStillProcessing = splitLineItemResults.some(({ paymentStatus }) => paymentStatus !== WebGivingPaymentResultStatus.Success);
    const showProcessingMessage = !hasAnyFailedPayments && arePaymentsStillProcessing;

    const title: string | JSX.Element = showProcessingMessage
        ? <Text>Thank you. Your {NounLowerCase} is still being processed.</Text>
        : <Text>Thank you for your generosity!</Text>;

    const successMessage = (<Text params={{ emailAddress }}>{`We've sent a ${NounLowerCase} receipt to your email address {{emailAddress}}.`}</Text>);

    const processingMessage = (<Text params={{ emailAddress }}>
        {`Your ${NounPluralLowerCase} are being processed. You will receive a ${NounLowerCase} receipt to your email address {{emailAddress}} when the ${NounPluralLowerCase} are processed.`}
    </Text>);

    const giftRecurringCompleteMessage = (
        <>
            <Text>{`Your ${isRecurring ? 'recurring ' : ''}${NounLowerCase} ${statusText}. `}</Text>
            {secondPart ? secondPart : ''}
        </>
    );

    let giftCompleteMessage: JSX.Element;
    if (isRecurring || isOneTimeFutureGift) {
        giftCompleteMessage = giftRecurringCompleteMessage;
    } else {
        giftCompleteMessage = showProcessingMessage ? processingMessage : successMessage;
    }

    const target = isRecurring ? 'Split Giving Recurring Success Message' : 'Split Giving One-time Success Message';

    return [
        <>
            <h1 key="title">{title}</h1>
            <LineItemSummaryTable splitLineItemResults={splitLineItemResults} paymentLabel={paymentLabel} />
            <p className="lead"
                key="lead"
                data-pp-at-target={target}>
                {giftCompleteMessage}
            </p>
            {recurringSuggestion}
        </>
    ] as any as JSX.Element;
});